import classNames              from 'classnames';
import React, { FC, useState } from 'react';

import { StyledContainer }                 from '../../../containers';
import { Position, SemanticUIColor }       from '../../../../types';
import { HexagonShape, HexagonShapeProps } from '../visual/HexagonShape';

interface Props {
	hexSize?: HexagonShapeProps['size'],
	hexColor?: HexagonShapeProps['color'],
	messageHoverEffect?: boolean,
	hexRotateEffect?: boolean,
}

const defaultProps: Props = {
	hexSize:            250,
	hexColor:           SemanticUIColor.BLUE,
	messageHoverEffect: true,
	hexRotateEffect:    true,
}

const MessageInRotatingHex: FC<Props> = ( props ) => {
	
	return (
		
		<div style={ { width: '100%', height: props.hexSize } } className={ 'position--relative fade-in' }>
			
			<StyledContainer position={ Position.ABSOLUTE } zIndex={ 100 } top={ 0 } left={ 'calc(50% - 125px)' } className={ classNames( 'opacity--25', { 'rotate-slowly': props.hexRotateEffect } ) }>
				<HexagonShape size={ props.hexSize } color={ props.hexColor } rotation={ 0 }/>
			</StyledContainer>
			
			<StyledContainer position={ Position.ABSOLUTE } zIndex={ 300 } top={ 'calc( 50% )' } left={ '35%' } right={ '35%' } className={ classNames( { 'opacity--50 opacity-hover--75': props.messageHoverEffect } ) }>
				
				{ props.children }
			
			</StyledContainer>
		
		</div>
	);
};

MessageInRotatingHex.defaultProps = defaultProps;

export { MessageInRotatingHex }
